import { render } from "./ClassRoomDialog.vue?vue&type=template&id=0e8281c5&scoped=true&ts=true"
import script from "./ClassRoomDialog.vue?vue&type=script&lang=ts"
export * from "./ClassRoomDialog.vue?vue&type=script&lang=ts"

import "./ClassRoomDialog.vue?vue&type=style&index=0&id=0e8281c5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8281c5"]])

export default __exports__